import moment from 'moment';
import store from "./store/index";


export function getTimeDiffInMins(timeDiff){
  var hours =parseInt(timeDiff.substring(0,2))
  var mints =parseInt(timeDiff.substring(3,5))

  return (hours*60+mints)

}

export function getTimeinHHMMFormat(element){
  return moment(store.getState().currentRaceTime,'YYYYMMDD HH:mm').subtract(parseInt(getTimeDiffInMins(store.getState().timeSettings[element])),'minutes').format("HH:mm")
}

export function getRealTimeinHHMMFormat(element){
  return moment(store.getState().exactTimeSettings[element],'HH:mm')
        .add('minutes' , store.getState().localTimeOffSetToGmt)
        .format("HH:mm")

}
